
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageSlug]/color/[colorValue]",
      function () {
        return require("private-next-pages/[pageSlug]/color/[colorValue].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageSlug]/color/[colorValue]"])
      });
    }
  